<div *ngIf="showSessionPopup" class="modal-overlay">
  <div class="custom-modal">
    <div class="modal-header">
      <h3 class="modal-title">Session Ended</h3>
    </div>
    <div class="modal-body">
      <p>Your session has ended because application is now active in another tab.</p>
      <p>
        <button class="btn-primary" (click)="onSessionConfirm()">OK</button>
      </p>
    </div>
  </div>
</div>

<!-- do not wrap the outlet in any div, this will add scrolls to main body and sidebar main container scrolls will be affected-->
<router-outlet *ngIf="!showSessionPopup"></router-outlet>
<div class="loader-div" id="ifas-loader-div-id" *ngIf="!showSessionPopup">
  <img class="loader-img" src="/assets/images/ajax-loader.gif" style="height: 120px;width: auto;" alt="Loading…"/>
</div>
